import { Component, OnInit, inject } from '@angular/core';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { TIPPY_REF } from '@ngneat/helipopper';

@Component({
  selector: 'app-ai-tooltip',
  templateUrl: './ai-tooltip.component.html',
  styleUrls: ['./ai-tooltip.component.scss'],
})
export class AITooltipComponent implements OnInit {
  account: Account;
  tippy = inject(TIPPY_REF);
  constructor() {
    this.account = this.tippy.data.account;
  }

  ngOnInit() {}
}
